export const UserIds = {
  SYSTEM: "11111111-1111-1111-1111-111111111111"
}